import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
//import { useParams } from 'react-router';
import { useUser } from '../contexts/userContext.js';
import { NO_BUDGET } from '../static/constants.js';

const SelectionContext = createContext(null);

export const SelectionProvider = ({ children }) => {
  //const { orgId, budgetId } = useParams();
  const { user } = useUser();

  const orgId = user?.activeOrganization;
  const budgetId = user?.activeBudget?.id ?? NO_BUDGET;
  const isReady = !!(orgId && budgetId);

  const value = {
    orgId,
    budgetId,
    isReady
  };

  return (
    <SelectionContext.Provider value={value}>
      {children}
    </SelectionContext.Provider>
  );
};

SelectionProvider.propTypes = {
  children: PropTypes.node
};

export const useSelection = () => useContext(SelectionContext);
